import type { ReactNode } from 'react';
import { Icon } from './icon';

/**
 * Mockup `.table-toolbar`: a max-360 search input with a leading magnifier,
 * optional secondary filter buttons, a flexible spacer and an optional
 * `trailing` slot.
 */
export function Toolbar({
  search,
  onSearch,
  placeholder,
  filters,
  trailing,
}: {
  search: string;
  onSearch: (v: string) => void;
  placeholder: string;
  filters?: ReactNode;
  trailing?: ReactNode;
}): JSX.Element {
  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-[var(--m-divider)] px-5 py-4">
      <div className="relative max-w-[360px] flex-1">
        <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--m-fg-subtle)]">
          <Icon name="search" size={16} />
        </span>
        <input
          type="search"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className="w-full rounded-[var(--m-r-md)] border-[1.5px] border-[var(--m-border)] bg-[var(--m-surface)] py-3 pl-[42px] pr-3.5 text-[15px] text-[var(--m-fg)] outline-none transition focus:border-[var(--m-brand)] focus:ring-[3px] focus:ring-[var(--m-brand)]/15"
        />
      </div>
      {filters}
      <div className="flex-1" />
      {trailing}
      {/* Havia aqui um <Button icon="more-horizontal"> fixo, sem onClick e sem prop pra configurar:
          aparecia nas 3 listas sugerindo um menu que nunca existiu. Removido. */}
    </div>
  );
}
